import { jsx as _jsx } from "theme-ui/jsx-runtime";
import Flex from './Flex';
export default function Row(props) {
    return _jsx(Flex, Object.assign({ wrap: "wrap", sx: { marginX: '-columnGap' } }, props));
}
//# sourceMappingURL=Row.js.map